import ChevronLeftIcon from "./ChevronLeftIcon.mjs";

const BackIcon = class extends ChevronLeftIcon {}

export default BackIcon;